export default __webpack_public_path__ + "static/media/rental-badge-kids.2a32e62d.png";